import { render } from "./RegionOffer.vue?vue&type=template&id=696b0de6&scoped=true"
import script from "./RegionOffer.vue?vue&type=script&lang=js"
export * from "./RegionOffer.vue?vue&type=script&lang=js"

import "./RegionOffer.vue?vue&type=style&index=0&id=696b0de6&lang=scss"
import "./RegionOffer.vue?vue&type=style&index=1&id=696b0de6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696b0de6"],['__file',"webpack-assets/vue/templates/product/catalog/parts/RegionOffer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "696b0de6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('696b0de6', __exports__)) {
    api.reload('696b0de6', __exports__)
  }
  
  module.hot.accept("./RegionOffer.vue?vue&type=template&id=696b0de6&scoped=true", () => {
    api.rerender('696b0de6', render)
  })

}


export default __exports__